import React, { useState } from 'react';
import { getImages } from '../const';
import RefineMatcheMap from './RefineMatcheMap';

const PerfectMatchModal = ({ close, isTabView }) => {
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [formData, setFormData] = useState({
        "In-House": false,
        "Non-OEM": false,
        "Full Send": false
    });

    // Handle checkbox change
    const handleCheckboxChange = (event) => {
        const { id, checked } = event.target;
        setFormData(prev => ({ ...prev, [id]: checked }));
    };

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();
        console.log({
            selectedRegion,
            ...formData
        });
    };
 
    return (
        <>
            <div className="modal-content p-0">
                <div className="modal-header p-3 chat-modal-header">
                    <h1 className="modal-title filter-modal-title text-center w-100">
                        Filter{isTabView ? 's' : ' Perfect Match'}
                    </h1>
                    <button className="sm-box-close mt-0" type="button" onClick={close}>
                        <img src={getImages('white-close.svg')} />
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="modal-body perfect-filter-body">
                        <div className='row mb-3'>
                            {["In-House", "Non-OEM", "Full Send"].map(item => (
                                    <div className='col-md-4 col-6 mb-4 mb-md-0' key={item}>
                                        <div className='pf-box'>
                                            <div className="custom-checkbox">
                                                <input
                                                    type="checkbox"
                                                    className="styled-checkbox"
                                                    id={item}
                                                    checked={formData[item]}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label htmlFor={item} className='text-uppercase'>
                                                    {item} 
                                                    {item == "In-House" ? <img className='ms-3' src={getImages(`in-house.svg`)} /> : 
                                                        item == "Non-OEM" ? <img className='ms-3' src={getImages(`Non-OEM.svg`)} /> :  
                                                        <img className='ms-3' src={getImages(`Full_Send.svg`)} />
                                                    }
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                            ))}
                        </div>
                        <div className='pf-box'>
                            <RefineMatcheMap 
                                selectedRegion={selectedRegion} 
                                setSelectedRegion={setSelectedRegion} 
                            />
                        </div>
                        <div className='text-center mt-4'>
                            <button type='submit' className={`red-btn ${isTabView ? 'w-100': 'w-190'}`}>APPLY</button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};

export default PerfectMatchModal;
